<template>
  <section class="admin superadmin hero is-light is-fullheight">
    <TheNavbar />
    <div class="hero-body">
      <div class="columns">
        <div class="column is-narrow is-hidden-touch">
          <div class="menu-container is-flex has-text-white">
            <AppMenu class="sidebar navbar is-primary" />
          </div>
        </div>
        <div class="column">
          <div class="child-container">
            <RouterView />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TheNavbar from '@/components/SuperAdmin/TheNavbar.vue';
import AppMenu from '@/components/SuperAdmin/AppMenu.vue';

export default {
  name: 'SuperAdmin',
  components: {
    TheNavbar,
    AppMenu,
  },
};
</script>

<style scoped>
.admin.hero.is-fullheight {
  height: calc(100vh - 3.25rem);
  min-height: calc(100vh - 3.25rem);
}

.admin .hero-body {
  padding: 0;
  align-items: initial;
}

.admin .columns {
  padding: 0;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  flex-grow: 1;
  flex-shrink: 0;
}

.column.is-narrow {
  background: linear-gradient(#39455B, #262F40);
}

.menu-container {
  flex-grow: 1;
  flex-shrink: 0;
}

.column {
  padding: 0;
}

.child-container {
  height: calc(100vh - 3.25rem);
  overflow-y: auto;
  padding: 1rem;
  margin-top: 3rem;
}

@media screen and (max-width: 1087px) {
  .child-container {
    width: 100vw;
  }
}
</style>

<style>
@media screen and (max-width: 1087px) {
  #app .hero.is-light .sidebar.navbar-menu {
    background: #39455B;
  }
}

@media screen and (min-width: 1088px) {
  #app .hero.is-light .sidebar.navbar-menu {
    background: whitesmoke;
  }
}
</style>
